export const implementationChecklistRegion = 'Implementation Checklist Sidebar';

export default {
  implementationChecklistRegion,
};
